module.exports = __webpack_public_path__ + "static/media/Life Can't Wait.351891a9.png";